module.exports = __webpack_public_path__ + "static/media/fokusthema-immobilienverwaltung.31498ce7.webp";